import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";

import "./styles/fonts.css";
import "./styles/tokens.css";
import "./styles/base.css";
// The flags <CountryCell> draws: one stylesheet of `background-image: url(…)`
// rules, one per country. It belongs at the entry point rather than inside the
// component because it is global CSS — a package's own class names, not a
// module — and the app wants exactly one copy of it. The SVGs stay out of the
// stylesheet and the browser fetches only the flags a page renders, which is
// what the assetsInlineLimit rule in vite.config.ts is there to hold.
import "flag-icons/css/flag-icons.min.css";

import { App } from "./App";
import { queryClient } from "./lib/queryClient";
import { ToastProvider } from "./components/Toast/Toast";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
